import { InjectionToken } from '@angular/core';

import { UwpEnvironment } from '@digital-platform/unified-wp-common-domain';

export const UWPENVIRONMENT = new InjectionToken<UwpEnvironment>(
  'uwpEnvironment'
);
